import { useEffect, useState } from "react";
import {
  fetchPublicAuthFounderHeroUrl,
  getDefaultAuthFounderHeroUrl,
} from "../services/authFounderHero.service";

export default function useAuthFounderHeroImage() {
  const [heroImageUrl, setHeroImageUrl] = useState(getDefaultAuthFounderHeroUrl);

  useEffect(() => {
    let active = true;
    void fetchPublicAuthFounderHeroUrl().then((url) => {
      if (active && url) setHeroImageUrl(url);
    });
    return () => {
      active = false;
    };
  }, []);

  return heroImageUrl;
}
